import React, { useEffect } from "react";
import { Box, Grid } from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import Tabs1Charts from "./Tabs1Charts";
import "./style.css";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useDispatch, useSelector } from "react-redux";
import { openErrorOrWarningDialog } from "../../../Redux/Actions/InputData";
import ErrorOrWarningDialog from "../../../Components/Modals/ErrorOrWarningDialog";

export default function MediumCompare() {

  const dispatch: any = useDispatch();
  const [tabsValue, setTabsValue] = React.useState("1");

  const selectedUsecaseId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId
  );
  const selectedCategoryId = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId
  );
   /* const [selectScenario2, setSelectScenario2] = useState<any>("Scenario 1");
  const [selectFolder, setSelectFolder] = useState<any>("Monthly");
  const [selectedFolderId, setSelectedFolderId] = useState<any>(0);
  const [selectBaseline, setSelectBaseline] = useState<any>("Baseline");
  const [selectScenario1, setSelectScenario1] = useState<any>("Baseline");
  const [selectedScenarioId, setSelectedScenarioId] = useState<any>(0);
  const [folderOptions, setFolderOptions] = useState<any>([]);
  const [scenarioOptions, setScenarioOptions] = useState<any>([]);
  const [secondScenarioOptions, setSecondScenarioOptions] = useState<any>([]);
*/
const selectedFolderId = useSelector(
  (state: any) => state.InputDataReducers.selectedFolderId);	
  const { isErrorDialog, errorMessage, isErrorOrWarningDialog,errorOrWarningMessage } = useSelector(
    (state: any) => state.InputDataReducers
  );
  const [distanceCostPerTonData, setDistanceCostPerTonData] = React.useState([]);
  const handleDownload = (e: any) => {
    let elem: any = document.getElementById('chartcontainer');
    html2canvas(elem).then(function (canvas) {
      var wid: number
      var hgt: number
      var img = canvas.toDataURL("image/png", wid = canvas.width);
      // var img = canvas.toDataURL("image/png", wid = canvas.width, hgt = canvas.height);
      // var hratio = hgt/wid
      var doc = new jsPDF('p', 'pt', 'a4');
      var width = 550 // doc.internal.pageSize.width;    
      var height = 600 // width * hratio
      doc.addImage(img, 'JPEG', 10, 10, width, height);
      doc.save('Compare_Charts.pdf');
    });
  }

  useEffect(()=>
  {
    if(selectedUsecaseId === undefined || selectedUsecaseId === 0 || selectedCategoryId === undefined || selectedCategoryId === 0)
    {
      dispatch(openErrorOrWarningDialog("Please select atleast one usecase, category."));
    }
  },[])

  // const handleChangeTabs = (event: React.SyntheticEvent, newValue: string) => {
  //   setTabsValue(newValue);
  // };
  // useEffect(() => {   
  //   callFolderFilterApi();
  //   if(selectedFolderId)
  // }, []);
  /*
  const callFolderFilterApi = () => {
    dispatch(displayFolderList());
    const urls = API_BASE_URL + DISPLAY_FOLDER_LIST_API;
    const header = { accept: "application/json", "Content-Type": "application/json" };
    getRequest(urls, {}, header).then((response) => {
      if (response.status === 200 && response.data.success) {
        setFolderOptions(response.data.data);
        dispatch(displayFolderListSuccess(response.data.data));
      }
    }).catch((error) => {
      dispatch(openErrorDialog(error));
      dispatch(displayFolderListError(error.message));
    });
  }

  const callScenarioFilterApi = (params: any) => {
    dispatch(displayScenarioList());
    const urls = API_BASE_URL + DISPLAY_SCENARIO_FILTER_API;
    const header = { accept: "application/json", "Content-Type": "application/json" };
    getRequest(urls, {"folder_id": params.id}, header).then((response) => {
      if (response.status === 200 && response.data) {
        let responseArray = [];
        responseArray.push(response.data);
        setScenarioOptions(response.data);
        //console.log(scenarioOptions);
        dispatch(displayScenarioListSuccess(response.data));
      }
    }).catch((error) => {
      dispatch(openErrorDialog(error));
      dispatch(displayScenarioListError(error.message));
    });
  }

  const handleChangeSelectScenario = (event: any) => {
    // const { target: { value } } = event;
    // setSelectedScenarioId(value.id);
    // const filtereddata = scenarioOptions.filter((scenario: { id: number; }) => scenario.id !==value.id)
 
    // setSecondScenarioOptions(filtereddata); 

  };

  const handleChangeSelectFolder = (event: any) => {
    const { target: { value } } = event;
    setSelectFolder(value.folder);
    setSelectedFolderId(value.id);
    callScenarioFilterApi(value);
    distanceCostPerTonByScenarioApi();
  };

  
  const distanceCostPerTonByScenarioApi = () => {
    const urls = API_BASE_URL + DISPLAY_CHART_DISTANCE_PER_TON_API;
    const header = { accept: "application/json", "Content-Type": "application/json" };
    // getRequest(urls, {"folder_id": selectedFolderId, "scenario_id": selectedScenarioId}, header).then((response) => {
      getRequest(urls, {usecaseId: 1, category_Id:1,"folder_id": 2058, BaseLineOrScenarioId:0,"scenario_id": 35}, header).then((response) => {
      if (response.status === 200 && response.data) {
        setDistanceCostPerTonData(response.data);
      }
    }).catch((error) => {
      dispatch(openErrorDialog(error));
    });
  }

  const handleChangeSelectScenario1 = (event: any) => {
    const { target: { value } } = event;
    setSelectScenario1(value.scenario);
    //setSelectedScenarioId(value.scenario_id);
    //const filtereddata = scenarioOptions.filter((scenario: { scenario_id: any; }) => scenario.scenario_id !==value.scenario_id);

    const filtereddata = scenarioOptions.filter((scenario:any) => 
    {
      if(scenario.scenario_id !== value.scenario_id && scenario.scenario !=='BaseLine')
      return scenario;
    });
     setSecondScenarioOptions(filtereddata); 
  };

  const handleChangeSelectScenario2 = (event: any) => {
    const { target: { value } } = event;
    setSelectScenario2(value.scenario);
  }

  // const handleChangeSelectBaseline = (event: any) => {
  //   const { target: { value } } = event;
  //   setSelectBaseline(value);
  //   setSelectedScenarioId(value.scenario_id);
  //   const filtereddata = scenarioOptions.filter((scenario: { scenario_id: number; }) => scenario.scenario_id !==value.scenario_id)
  //    setSecondScenarioOptions(filtereddata); 

  //   // setSelectBaseline(value);
  // };

  // const handleDownload = (e: any) => {
  //   console.log('handleDownload: ', e);
  //   let canvasSave: any = document.getElementById('overall-cost-by-scenario');
  //   // canvasSave.fillStyle = "#ffffff";
  //   canvasSave.toBlob(function (blob: any) {
  //     saveAs(blob, "overall-cost-by-scenario.png");
  //   });
  //   let canvasSave2: any = document.getElementById('cost-comparision-split-by-time');
  //   canvasSave2.toBlob(function (blob: any) {
  //     saveAs(blob, "cost-comparision-split-by-time.png");
  //   });
  // };
*/
  return (
    <>
     {isErrorOrWarningDialog && (
        // eslint-disable-next-line react/jsx-no-undef
        <ErrorOrWarningDialog
        isErrorOrWarningDialog={isErrorOrWarningDialog}
        errorOrWarningMessage={errorOrWarningMessage}
        />
      )}
      <div>
        <div>
          {/* <div className="page-title">
            <h3>Compare scenarios</h3>
          </div> */}
          {/* <div className="filters">
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                <Select
                  id="simple-select-2"
                  value={selectFolder}
                  placeholder="Select Folder"
                  onChange={handleChangeSelectFolder}
                  renderValue={(selected: any) => selected}
                  className="select-short-term">
                     {folderOptions.map((d: any) => {
                  return (
                  <MenuItem key={d.id} value={d}>
                    {d.folder +' ('+ d.time_period + ')'}
                  </MenuItem>)
                })}                  
                </Select>
              </FormControl>
            </div>

            <div className="filter-item">
              <FormControl fullWidth>
                <Select
                  id="simple-select-3"
                  value={selectScenario1}
                  placeholder="Select Baseline"
                  onChange={handleChangeSelectScenario1}
                  renderValue={(selected: any) => selected}
                  className="select-short-term">
                       {scenarioOptions.map((d: any) => {
                  return (<MenuItem key={d.scenario_id} value={d}>{d.scenario}</MenuItem>)
                })}
              
                </Select>
              </FormControl>
            </div>

            <div className="filter-item">
              <FormControl fullWidth>
                <Select
                  id="simple-select-3"
                  value={selectScenario2}
                  placeholder="Select Scenario"
                  onChange={handleChangeSelectScenario2}
                  renderValue={(selected: any) => selected}
                  className="select-short-term">
               
                   {secondScenarioOptions.map((d: any) => {
                  return (<MenuItem key={d.scenario_id} value={d}>{d.scenario}</MenuItem>)
                })}
                </Select>
              </FormControl>
            </div>

            <div className="filter-item">
              <FormControl fullWidth>
                <div className="content-download-btn" onClick={handleDownload}>
                  <img src={btnDownloadIcon} alt="" /> <span> Download</span>
                </div>
              </FormControl>
            </div>
          </div> */}
        </div>
        <div id="chartcontainer" className="chart-area">
                  <Tabs1Charts filterArray={distanceCostPerTonData}/>
                </div>
        <div className="tabs-area">
          <Box sx={{ width: "100%", typography: "body1" }}>
            <TabContext value={tabsValue}>
              <TabPanel value="1">
                {/* <div className="legend-area">
                  <Grid container spacing={1}>
                    <Grid item xs={1} md={1} lg={1}>
                      <p className="legend-title">Legend</p>
                    </Grid>
                    <Grid item xs={2} md={2} lg={2}>
                      <p><span className="chartlegend production-cost"></span>Production Cost</p>
                    </Grid>
                    <Grid item xs={2} md={2} lg={2}>
                      <p><span className="chartlegend procurement-cost"></span>Procurement Cost</p>
                    </Grid>
                    <Grid item xs={3} md={3} lg={3}>
                      <p><span className="chartlegend ibtransport-cost"></span>Inbound Transportation Cost</p>
                    </Grid>
                    <Grid item xs={2} md={2} lg={2}>
                      <p><span className="chartlegend obtransport-cost"></span>Outbound Production Cost</p>
                    </Grid>
                  </Grid>
                </div> */}
               
              </TabPanel>
              <TabPanel value="2">
                <div>
                  <Grid container spacing={1}>
                    <Grid item xs={2} md={2} lg={2}>
                      <p>Legend</p>
                    </Grid>
                    <Grid item xs={2} md={2} lg={2}>
                      <p>Production Cost</p>
                    </Grid>
                    <Grid item xs={2} md={2} lg={2}>
                      <p>Procurement Cost</p>
                    </Grid>
                    <Grid item xs={2} md={2} lg={2}>
                      <p>Inbound Transportation Cost</p>
                    </Grid>
                    <Grid item xs={2} md={2} lg={2}>
                      <p>Outbound Production Cost</p>
                    </Grid>
                  </Grid>
                </div>
              </TabPanel>
              <TabPanel value="3">
                <div className="legend-area">
                  <Grid container spacing={1}>
                    <Grid item xs={2} md={2} lg={2}>
                      <p>Legend</p>
                    </Grid>
                    <Grid item xs={2} md={2} lg={2}>
                      <p>Production Cost</p>
                    </Grid>
                    <Grid item xs={2} md={2} lg={2}>
                      <p>Procurement Cost</p>
                    </Grid>
                    <Grid item xs={2} md={2} lg={2}>
                      <p>Inbound Transportation Cost</p>
                    </Grid>
                    <Grid item xs={2} md={2} lg={2}>
                      <p>Outbound Production Cost</p>
                    </Grid>
                  </Grid>
                </div>
              </TabPanel>
            </TabContext>
          </Box>
        </div>
      </div>
    </>
  );
}
